import { Link, useLocation } from "react-router-dom"


export default function BreadCrumbsAppoUser() {

    return(
        <div className="space-x-2 text-[14px]">
            <Link className="text-gray-400" to={'/dashboard/home'}>
                Dashboard
            </Link>
            <span>-</span>
            <span className='text-black font-bold'>I miei appuntamenti</span>
        </div>
    )
}